import { getConfiguration } from "@chr/common-web-ui-configuration";
import { getAxiosInstance } from "@chr/online-shared-microsite-core";

import { GetDisruptionsRequest, GetDisruptionsResponse } from '@/common/constants/map-display-types';

export const getDisruptions = async (request: GetDisruptionsRequest) => {
    const axios = await getAxiosInstance();
    const baseUrl = (await getConfiguration<AppConfig>()).gatewayApiUri;
    const url = `${baseUrl}/booking/Disruptions?showExpired=${request.showExpired}`;

    const headers = {
        'Content-Type': 'application/json'
    };

    const response = await axios.get<GetDisruptionsResponse>(url, { headers });
    return response.data;
};
